/* Phone finder quiz (sections/phone-finder.liquid). Scores phones from the
   unlocked-phones collection on the visitor's answers. Items = live price/stock
   from Liquid, specs = snippets/phone-finder-specs.liquid. */
(function(){
  var R=document.querySelector('[data-pf]');if(!R)return;
  function J(sel){try{return JSON.parse(R.querySelector(sel).textContent)}catch(e){return null}}
  var specs=J('[data-pf-specs]')||{},raw=J('[data-pf-items]')||[];
  var items=raw.filter(function(it){return specs[it.h]}).map(function(it){var s=specs[it.h];for(var k in s)it[k]=s[k];return it});
  var ORDER=['budget','brand','use','camera','size'];
  var steps={};R.querySelectorAll('[data-pf-step]').forEach(function(el){steps[el.getAttribute('data-pf-step')]=el});
  var bar=R.querySelector('[data-pf-bar]'),cnt=R.querySelector('[data-pf-count]'),back=R.querySelector('[data-pf-back]'),out=R.querySelector('[data-pf-out]');
  var app=R.querySelector('[data-pf-app]');
  var A={brand:[]},cur=0;
  var SHOP={Apple:'iPhones',Samsung:'Samsung Galaxy phones',Google:'Google Pixel phones',Motorola:'Motorola phones'};
  var COLL={Apple:'iphone',Samsung:'samsung',Google:'google-pixel',Motorola:'motorola'};
  var collBase=(document.documentElement.lang||'').indexOf('fr')===0?'/fr/collections/':'/collections/';

  function money(c){return '$'+(c/100).toLocaleString('en-CA',{minimumFractionDigits:2,maximumFractionDigits:2})}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}

  /* budget counts */
  R.querySelectorAll('[data-pf-n]').forEach(function(el){
    var b=+el.getAttribute('data-pf-n'),n=items.filter(function(it){return !b||it.p<=b*100}).length;
    el.textContent=n?n+' phone'+(n===1?'':'s'):'None right now';
  });

  function show(i,init){
    cur=i;var name=i<ORDER.length?ORDER[i]:'results';
    for(var k in steps)steps[k].hidden=(k!==name);
    var done=Math.min(i,ORDER.length);
    bar.style.width=(done/ORDER.length*100)+'%';
    cnt.textContent=i<ORDER.length?(i+1)+' of '+ORDER.length:'Your matches';
    back.hidden=(i===0);
    if(init)return;
    var top=app.getBoundingClientRect().top;
    if(top<0||top>window.innerHeight*.6)app.scrollIntoView({behavior:'smooth',block:'start'});
    var f=steps[name].querySelector('h2,.pf-opt');if(f){f.setAttribute('tabindex','-1');f.focus({preventScroll:true})}
  }

  ORDER.forEach(function(name,i){
    var el=steps[name],multi=el.hasAttribute('data-multi'),next=el.querySelector('[data-pf-next]');
    el.querySelectorAll('.pf-opt').forEach(function(b){
      b.setAttribute('aria-pressed','false');
      b.addEventListener('click',function(){
        var v=b.getAttribute('data-v');
        if(multi){
          var on=b.getAttribute('aria-pressed')!=='true';b.setAttribute('aria-pressed',on);
          A[name]=[].map.call(el.querySelectorAll('.pf-opt[aria-pressed="true"]'),function(x){return x.getAttribute('data-v')});
          next.disabled=!A[name].length;return;
        }
        el.querySelectorAll('.pf-opt').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
        A[name]=v;
        setTimeout(function(){i===ORDER.length-1?finish():show(i+1)},160);
      });
    });
    if(next)next.addEventListener('click',function(){show(i+1)});
    var skip=el.querySelector('[data-pf-skip]');
    if(skip)skip.addEventListener('click',function(){
      A[name]=[];el.querySelectorAll('.pf-opt').forEach(function(x){x.setAttribute('aria-pressed','false')});if(next)next.disabled=true;show(i+1);
    });
  });
  back.addEventListener('click',function(){if(cur>0)show(cur-1)});
  R.querySelector('[data-pf-restart]').addEventListener('click',function(){
    A={brand:[]};R.querySelectorAll('.pf-opt').forEach(function(x){x.setAttribute('aria-pressed','false')});
    var n=R.querySelector('[data-pf-next]');if(n)n.disabled=true;show(0);
  });

  /* scoring, each part 0..1 */
  function sCam(it,c){
    var z=it.z||0;
    if(c==='pro')return z>=3?1:z>=2?.6:.15;
    if(c==='great'){
      if(it.f)return it.t==='fold'?.85:.6;
      if(it.t==='pro'||it.t==='big')return it.y>=2021?1:.75;
      if(it.t==='budget')return it.b==='Google'?.85:(it.mp||0)>=50&&it.y>=2023?.6:.45;
      return it.y>=2022?.9:.7;
    }
    return 1;
  }
  function sBat(it,u){
    var t=it.bt||2;
    if(u==='heavy')return t>=3?1:t===2?.55:.1;
    if(u==='regular')return t>=2?1:.5;
    return 1;
  }
  function sSize(it,z){
    var s=it.s;
    if(z==='small'){if(it.f)return it.f==='flip'?.75:0;return s<=6.1?1:s<=6.3?.6:.15}
    if(z==='mid'){if(it.f)return .3;return s>=6&&s<=6.5?1:s<6?.6:.5}
    if(z==='big'){if(it.f)return it.f==='fold'?.7:.4;return s>=6.6?1:s>=6.3?.5:.1}
    return 1;
  }
  function sLong(it){return Math.max(0,Math.min(1,(it.u-new Date().getFullYear())/6))}

  function family(h){var f=h,p;do{p=f;f=f.replace(/-(pro-max|pro-xl|pro-fold|pro|plus|ultra|max|mini|fe|xl|edge|lite|5g|e)$/,'')}while(f!==p);return f}

  function rank(list,a){
    var B=+a.budget||0;
    return list.map(function(it){
      var over=B&&it.p>B*100;
      var t=.27*sCam(it,a.camera)+.23*sBat(it,a.use)+.23*sSize(it,a.size)+.2*sLong(it)+.07*(over?.4:1);
      return {it:it,t:t,over:over};
    }).sort(function(x,y){return y.t-x.t||x.it.p-y.it.p});
  }

  function finish(){
    var B=+A.budget||0,brands=A.brand||[],note='';
    var pool=items.filter(function(it){return !brands.length||brands.indexOf(it.b)>=0});
    if(A.size==='fold')pool=pool.filter(function(it){return it.f});
    var inB=pool.filter(function(it){return !B||it.p<=B*100+5000});
    var scored;
    if(inB.length){
      scored=rank(inB,A);
      /* only show a phone over budget when it clearly beats the best one inside it */
      var bestIn=scored.filter(function(x){return !x.over})[0];
      scored=scored.filter(function(x){return !x.over||!bestIn||x.t>bestIn.t+.08});
    }else if(pool.length){
      note='Nothing matches under '+money(B*100)+' right now, so here are the closest phones we have.';
      scored=rank(pool.slice().sort(function(x,y){return x.p-y.p}).slice(0,8),A);
    }else{
      var fold=A.size==='fold',all=items.filter(function(it){return !fold||it.f});
      note=fold?'We have no folding phones from that brand right now. Here are folding phones from other brands.':'None of those brands are available right now. Here are the best fits from everything else.';
      var allB=all.filter(function(it){return !B||it.p<=B*100+5000});
      scored=rank(allB.length?allB:all.slice().sort(function(x,y){return x.p-y.p}).slice(0,8),A);
    }
    /* one phone per model family first, then the rest */
    var seen={},pick=[],rest=[];
    scored.forEach(function(x){var f=family(x.it.h);if(seen[f])rest.push(x);else{seen[f]=1;pick.push(x)}});
    pick=pick.concat(rest).slice(0,8);
    render(pick,note);
    show(ORDER.length);
  }

  function pct(t){return Math.max(40,Math.min(99,Math.round(100*t)))}

  function reasons(x){
    var it=x.it,B=+A.budget||0,r=[];
    if(B)r.push(x.over?'From '+money(it.p)+', a little over your budget but a much better fit':'From '+money(it.p)+', inside your '+money(B*100).replace('.00','')+' budget');
    if(A.camera==='pro'&&it.z)r.push(it.z+'x optical zoom');
    else if(A.camera==='great'&&it.mp)r.push(it.mp+'MP main camera');
    if(A.use==='heavy'||A.use==='regular'){
      if(it.mah&&it.bt>=2)r.push(it.mah.toLocaleString('en-CA')+' mAh battery');
      else if(it.b==='Apple'&&it.bt>=3)r.push('One of the longest-lasting iPhone batteries');
    }
    if(it.f==='flip')r.push('Folds in half to fit any pocket');
    else if(it.f==='fold')r.push('Opens into a '+it.s+'" screen');
    else if(A.size==='small'&&it.s<=6.1)r.push(it.s+'" screen, easy to use with one hand');
    else if(A.size==='big'&&it.s>=6.6)r.push('Big '+it.s+'" screen');
    if(it.y>=new Date().getFullYear()-2)r.push('Released in '+it.y);
    return r.slice(0,4);
  }
  function facts(it){
    var f=[it.s+'" screen',it.z?it.z+'x zoom':'No zoom lens'];
    if(it.mah)f.push(it.mah.toLocaleString('en-CA')+' mAh');
    f.push(String(it.y));
    return f.map(function(x){return '<li>'+esc(x)+'</li>'}).join('');
  }
  function card(x,top){
    var it=x.it,img=it.i?'<img src="'+esc(it.i)+'" alt="'+esc(it.n)+'" loading="lazy" width="400" height="400">':'';
    var price='<p class="pf-price"><span>From</span> <b>'+money(it.p)+'</b>'+(it.g?' <small>'+esc(it.g)+'</small>':'')+(x.over?' <em>Over budget</em>':'')+'</p>';
    if(top){
      return '<article class="pf-best"><div class="pf-best__img">'+img+'</div><div class="pf-best__body"><span class="pf-badge">'+pct(x.t)+'% match &middot; Your best match</span><h3>'+esc(it.n)+'</h3>'+price+
        '<ul class="pf-why">'+reasons(x).map(function(r){return '<li>'+esc(r)+'</li>'}).join('')+'</ul><ul class="pf-facts">'+facts(it)+'</ul>'+
        '<a class="btn btn--accent pf-cta" href="'+esc(it.u)+'">See grades and prices</a></div></article>';
    }
    return '<a class="pf-alt" href="'+esc(it.u)+'"><span class="pf-alt__pct">'+pct(x.t)+'% match</span><div class="pf-alt__img">'+img+'</div><h3>'+esc(it.n)+'</h3>'+price+'<ul class="pf-facts">'+facts(it)+'</ul></a>';
  }
  function render(list,note){
    if(!list.length){out.innerHTML='<p class="pf-note">We couldn\'t load phones right now. Browse <a href="'+collBase+'unlocked-phones">all unlocked phones</a>.</p>';return}
    var h=(note?'<p class="pf-warn">'+esc(note)+'</p>':'')+card(list[0],true);
    var more=list.slice(1);
    if(more.length){
      h+='<h2 class="pf-sub">More great options</h2><div class="pf-alts">'+more.map(function(x,i){return card(x).replace('class="pf-alt"','class="pf-alt'+(i>=3?' pf-alt--more" hidden':'"'))}).join('')+'</div>';
      if(more.length>3)h+='<div class="pf-actions pf-actions--center"><button type="button" class="pf-skip" data-pf-more>Show '+(more.length-3)+' more</button></div>';
    }
    var bs=(A.brand||[]).length===1?A.brand[0]:null;
    h+='<p class="pf-foot">Prices and stock are live. Each phone page shows every grade and storage size. '+(bs?'<a href="'+collBase+COLL[bs]+'">Shop all '+esc(SHOP[bs])+'</a>':'<a href="'+collBase+'unlocked-phones">Shop all unlocked phones</a>')+'</p>';
    out.innerHTML=h;
    var m=out.querySelector('[data-pf-more]');
    if(m)m.addEventListener('click',function(){out.querySelectorAll('.pf-alt--more').forEach(function(x){x.hidden=false});m.remove()});
  }

  show(0,true);
  app.classList.add('is-ready');
})();
